import { render, staticRenderFns } from "./General.vue?vue&type=template&id=77b5ca2c&scoped=true&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.vue?vue&type=style&index=0&id=77b5ca2c&lang=scss&scoped=true&"
import style1 from "./General.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b5ca2c",
  null
  
)

export default component.exports